import React from "react";
import useTrackClaimFlow, {
  TRACK_CLAIM_CPR_CLAIM_NUMBER,
  TRACK_CLAIM_LOGIN_OTP,
  TRACK_CLAIM_DETAILS
} from "../../../hooks/useTrackClaimFlow";
import TrackClaimCprClaimNumberPage from "./trackClaimCprClaimNumberPage";
import TrackClaimLoginOtpPage from "./trackClaimLoginOtpPage";

const TrackClaimFlow = () => {
  const { currentStep } = useTrackClaimFlow();

  const PageRenderer = () => {
    switch (currentStep?.name) {
      case TRACK_CLAIM_CPR_CLAIM_NUMBER:
        return <TrackClaimCprClaimNumberPage />;
      case TRACK_CLAIM_LOGIN_OTP:
        return <TrackClaimLoginOtpPage />;
      case TRACK_CLAIM_DETAILS:
        return null;
      default:
        return <TrackClaimCprClaimNumberPage />;
    }
  };

  return (
    <div className="mainCarDetailsModal pt-[1%] pb-[5%] max767:w-full max767:overflow-y-scroll max767:pt-16 max767:pb-[30%] max767:h-screen ipad:pt-[10%] ipad:h-[93vh] ipad:overflow-y-scroll">
      <PageRenderer />
    </div>
  );
};

export default TrackClaimFlow;
